/**
 * unstable prefix for profile banners
 */
export const MATRIX_UNSTABLE_PROFILE_BANNER_PROPERTY_NAME = 'chat.commet.profile_banner';
export const MATRIX_COMMET_UNSTABLE_PROFILE_COLOR_SCHEME_PROPERTY_NAME =
  'chat.commet.profile_color_scheme';
/**
 * @deprecated
 */
export const MATRIX_COMMET_UNSTABLE_PROFILE_BIO_PROPERTY_NAME = 'chat.commet.profile_bio';
export const MATRIX_COMMET_UNSTABLE_PROFILE_STATUS_PROPERTY_NAME = 'chat.commet.profile_status';
export const MATRIX_CINNY_UNSTABLE_ACCOUNT_SPACES_PROPERTY_NAME = 'in.cinny.spaces';
export const MATRIX_CINNY_UNSTABLE_STATE_ROOM_POWER_LEVELS_LABEL_PROPERTY_NAME =
  'in.cinny.room.power_level_tags';
export const MATRIX_LEGACY_ELEMENT_UNSTABLE_ACCOUNT_RECENT_EMOJIS_PROPERTY_NAME =
  'io.element.recent_emoji';
export const MATRIX_ACCOUNT_RECENT_EMOJIS_PROPERTY_NAME = 'm.recent_emoji';
export const MATRIX_ELEMENT_UNSTABLE_STATE_ROOM_WIDGET_PROPERTY_NAME = 'im.vector.modular.widgets';

export const MATRIX_UNSTABLE_STATE_ROOM_BANNER_PROPERTY_NAME =
  'page.codeberg.everypizza.room.banner';
